module.exports = __webpack_public_path__ + "static/media/Valley-sunset.dbd31c49.svg";